import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/about.css";
import AboutAccordionSection from "./AboutAccordionSection";

import about3 from "../assets/img/about-3.png";
import AOS from "aos";
import "aos/dist/aos.css";
const About = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
    });
  }, []);
  return (
    <div className="about-page">
      {/* HERO SECTION */}
      <section className="about-hero" data-aos="fade-up">
        {/* BLURRED IMAGE LAYER */}
        <div className="hero-bg"></div>

        {/* CONTENT (NOT BLURRED) */}
        <div className="hero-content text-center text-white">
          <div className="container">
            <h1 className="fw-bold text-white">About Our Firm</h1>
            <p className="mt-3">
              A leading national law firm delivering strategic, trusted legal
              solutions
            </p>
          </div>
        </div>
      </section>

      {/* WHO WE ARE */}
      <section
        className="about-section "
        data-aos="fade-up"
        data-aos-delay="100"
      >
        <div className="container-fluid">
          <div className="row align-items-center px-3">
            <div className="col-md-6">
              <h2 className="section-title">Who We Are</h2>
              <p>
                Videlicet Law is a Mumbai-based law firm known for its strategic
                legal counsel, deep domain expertise, and strong ethical
                foundations. The firm advises and represents individuals,
                cooperative housing societies, businesses, institutions, and
                professionals across a wide range of legal matters, with
                particular strength in property law, redevelopment, cooperative
                law, regulatory litigation, and constitutional issues.
              </p>
              <p>
                Our practice is distinguished by its unique integration of legal
                expertise with technical and structural understanding, allowing
                us to deliver solutions that are not only legally sound but also
                practically effective. We believe that law must serve clarity,
                justice, and long-term stability and every matter entrusted to
                us is handled with precision, accountability, and professional
                rigor.{" "}
              </p>
            </div>
            <div className="col-md-6">
              <div className="image-card">
                <img
                  src={about3}
                  alt="Law Image 1"
                  className="img-fluid hover-effect"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* MANAGEMENT STRUCTURE */}
      {/* <section className="about-section bg-light" data-aos="fade-up"  data-aos-delay="100">
        <div className="container-fluid px-3">
          <h2 className="section-title text-center">Management Structure</h2>
          <p className="text-start mt-3">
           Our management structure comprises of a collegial partnership that is led by an elected executive committee which includes two joint managing partners and three other partners. With a transparent and accountable management team, we are seen as the law firm that heralded a paradigm change in India in institutionalising and professionalising law firm ownership and management. Our one nation, one firm, one balance sheet approach is unique for India.
          </p>
        </div>
      </section> */}

      {/* <AboutAccordionSection/> */}
    </div>
  );
};

export default About;
